module.exports = __webpack_public_path__ + "static/img/icon_13.1b910505.png";